// project import
import getMenuItems from 'menu-items';
import { useMemo } from 'react';
import NavGroup from './NavGroup';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

function Navigation() {
    const menuItems = useMemo(() => getMenuItems(), []);

    return (
        <div>
            {menuItems.items.map((item) => (item.type === 'group' ? <NavGroup key={item.id} item={item} /> : null))}
        </div>
    );
}

export default Navigation;
